/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'clsx';
import AButton from 'components/Antd/Button';
import ComplianceTable from '../ComplianceTable';
import classes from './Block.module.scss';

const Block = ({
  className,
  title,
  data,
  onAdd,
  onArchive,
  onDelete,
  onRenew,
  onDuplicate,
  onEdit,
  onUnarchive,
  onUpdateDocument,
  type,
  newDataIds,
}) => {
  const dataLength =
    (data || []).filter((obj) => {
      return obj.status !== 'archived';
    })?.length || 0;
  const noContent = !data?.length;
  return (
    <div className={cn(classes.wrapper, className)}>
      <div className={classes.tags}>
        <span className={classes.tag}>
          <span className={classes.tagText}>{title}</span>
          <span className={classes.tagCount}>{dataLength}</span>
        </span>
        {!noContent && (
          <AButton type="primary" onClick={onAdd} size="large">
            Add
          </AButton>
        )}
      </div>
      {noContent ? (
        <div className={classes.noContent}>
          <div>
            <span>There is no data here.</span>
            <AButton type="primary" onClick={onAdd} size="large">
              Add Data
            </AButton>
          </div>
        </div>
      ) : (
        <ComplianceTable
          onArchive={onArchive}
          onDelete={onDelete}
          onRenew={onRenew}
          onEdit={onEdit}
          onDuplicate={onDuplicate}
          onUnarchive={onUnarchive}
          onUpdateDocument={onUpdateDocument}
          data={data.map((d) => ({
            ...d,
            isNewFlag: (newDataIds || []).includes(d.id),
          }))}
          type={type}
        />
      )}
    </div>
  );
};

export default Block;
